import { t } from "i18next";
import { ObjectsSelect } from "../EmployeeList/form-config";
import {
  ClickableActionListCell,
  ControllerStatusCell,
  DiagnosticsCell,
  InputTextCustom,
  SimpleTextCell,
} from "./Components";
import FormItem from "../../components/FormItem";
import { TextFilter } from "../../components/Filters/TextFilter";
import { SelectSimpleObject } from "../../components/Filters/ObjectFilter";

export const formFields = {
  searchParams: "searchParams",
  facilitiesIds: "facilitiesIds",
  consoleName: "consoleName",
  protectionObjectId: "protectionObjectId"
};

export const getColumns = ({ control, tableNameSearchParams, setValue, writeSearchDataToSessionStorage }) => [
  {
    id: "name",
    numeric: false,
    clickable: false,
    enableSorting: false,
    size: "170px",
    RowCell: (props) => <InputTextCustom {...props} />,
    HeaderCell: () => (
      <FormItem
        control={control}
        name={`${formFields.searchParams}.${formFields.consoleName}`}
        sx={{ width: "100%" }}
        input={(props) => (
          <TextFilter
            placeholder={"Название пульта"}
            className="select-in-table small-light"
            writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
            storageValue="consoleNameStorage"
            {...props}
          />
        )}
      />
    ),
  },
  {
    id: "id",
    numeric: false,
    clickable: false,
    enableSorting: false,
    size: "150px",
    RowCell: (props) => <SimpleTextCell {...props} />,
    HeaderCell: () => (
      <div
        style={{
          color: "var(--headers)",
          fontSize: "16px",
          fontWeight: "500",
        }}
      >
        {t("tableHeader:controllerId")}
      </div>
    ),
  },
  {
    id: "facilities",
    label: t("tableHeader:facilities"),
    numeric: false,
    clickable: false,
    enableSorting: false,
    size: "150px",
    HeaderCell: () => (
      <FormItem
        control={control}
        label={t("tableHeader:protectionObjectName")}
        name={`${formFields.searchParams}.${formFields.protectionObjectId}`}
        sx={{ width: "100%" }}
        input={(props) => (
          <SelectSimpleObject
            {...props}
            showSearch
            IsTableheader={true}
            className="select-in-table small-light"
            writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
            storageValue="protectionObjectIdStorage"
            storageName={tableNameSearchParams}
            name={`${formFields.searchParams}.${formFields.protectionObjectId}`}
            setValue={setValue}
          />
        )}
      />
    ),
    RowCell: (props) => <ClickableActionListCell {...props} />,
  },
  {
    id: "hasDiagnostics",
    label: t("Диагностика"),
    numeric: false,
    clickable: false,
    enableSorting: false,
    size: "160px",
    RowCell: (props) => <DiagnosticsCell {...props} />,
    HeaderCell: () => (
      <div
        style={{
          color: "var(--headers)",
          fontSize: "16px",
          fontWeight: "500",
          textAlign: "center",
        }}
      >
        {t("Диагностика")}
      </div>
    ),
  },
  {
    id: "status",
    label: t("tableHeader:controllerStatus"),
    numeric: false,
    clickable: false,
    enableSorting: false,
    size: "120px",
    mode: "edit",
    RowCell: (props) => <ControllerStatusCell {...props} />,
    HeaderCell: () => (
      <div
        style={{
          color: "var(--headers)",
          fontSize: "16px",
          fontWeight: "500",
          textAlign: "center",
        }}
      >
        {t("tableHeader:controllerStatus")}
      </div>
    ),
  },
];
